<!-- 活动管理 新增/编辑（动态表单，参考 basebrandAction：由父页面传入 actionData，字段取 getJur 的 jurFormVoList 驱动） -->
<template>
  <div class="demo-drawer__content data_action_form">
    <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formConfig.length">
      <!-- 标题栏 -->
      <div class="table_content_box title_box">{{ dataActionBox.boxTitle }}</div>
      <div class="table_content_box">
        <!-- 主要信息 -->
        <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini"
          :show-message="false">
          <el-row ref="baseFormRow">
            <template v-for="(field, fKey) in formConfig">
              <el-form-item v-if="field.isShow == 1" :key="fKey" :prop="field.entityField"
                :rules="field.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                <label slot="label" v-html="field.showField"></label>
                <!-- 检索方案搜索 -->
                <el-input v-if="field.fieldType == 'search'" :disabled="field.isChange == 0" clearable
                  :ref="field.entityField"
                  v-model.trim="sendDataInfo[field.entityField]"
                  @keyup.enter.native="openSearch(field.searchId, field.setField, field.entityField, field.isIndex)">
                  <el-button @click="openSearch(field.searchId, field.setField, field.entityField, field.isIndex)"
                    slot="append" icon="el-icon-search"></el-button>
                </el-input>
                <!-- 下拉选择/枚举 -->
                <el-select v-else-if="field.fieldType == 'formatter'"
                  v-model="sendDataInfo[field.entityField]" :placeholder="'请选择'" clearable size="mini"
                  @change="$forceUpdate()">
                  <el-option v-for="opt in getFormatterOptions(field)" :key="opt.key"
                    :label="opt.value" :value="opt.key"></el-option>
                </el-select>
                <!-- 日期 -->
                <el-date-picker v-else-if="field.fieldType == 'date'" v-model="sendDataInfo[field.entityField]"
                  type="date" :placeholder="field.showField" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
                  style="width:100%"></el-date-picker>
                <!-- 多行文本 -->
                <el-input v-else-if="field.fieldType == 'textarea'" v-model.trim="sendDataInfo[field.entityField]"
                  type="textarea" :maxlength="field.maxlength || 200" show-word-limit clearable></el-input>
                <!-- 文本 / 其他 -->
                <el-input v-else
                  v-model.trim="sendDataInfo[field.entityField]"
                  :maxlength="field.maxlength || $store.state.inputLength" clearable></el-input>
              </el-form-item>
            </template>
          </el-row>
        </el-form>
        <!-- 明细操作 -->
        <el-form :inline="true" size="mini" v-if="detailFormConfig.length">
          <div id="operateBtn">
            <el-button type="primary" size="mini" @click="addDetail">新增明细</el-button>
            <el-button type="primary" size="mini" @click="deleteDetails" :disabled="selectedDetailIndex < 0">删除明细</el-button>
          </div>
          <!-- 明细信息 -->
          <el-table class="baseTable" ref="detailTableRef" :data="detailList" border size="mini"
            @row-click="clickDetailRow" :height="mxHeight">
            <el-table-column width="80" label="选择">
              <template slot-scope="scope">
                <el-radio v-model="selectedDetailIndex" :label="scope.$index" border size="mini">
                  <i class="el-icon-thumb"></i>
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <template v-for="(col, cKey) in detailFormConfig">
              <el-table-column v-if="col.isShow == 1" :key="cKey" :prop="col.entityField" :label="col.showField"
                :min-width="col.fieldWeight || 120" show-overflow-tooltip>
                <template slot-scope="scope">
                  <!-- 检索方案字段：行内输入框 + 检索按钮 -->
                  <el-input v-if="col.fieldType == 'search'" :ref="col.entityField" clearable
                    v-model="detailList[scope.$index][col.entityField]"
                    @keyup.enter.native="openDetailSearch(col.searchId, scope.$index, col.entityField, col.setField)">
                    <el-button slot="append" icon="el-icon-search"
                      @click="openDetailSearch(col.searchId, scope.$index, col.entityField, col.setField)"></el-button>
                  </el-input>
                  <!-- 日期 -->
                  <span v-else-if="col.fieldType == 'date'">
                    <span v-if="detailList[scope.$index][col.entityField]">
                      {{ $common.getLocalTime(detailList[scope.$index][col.entityField]) }}
                    </span>
                  </span>
                  <span v-else>{{ detailList[scope.$index][col.entityField] }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </el-form>
      </div>
    </el-card>
    <!-- 底部操作栏 -->
    <div class="foot">
      <el-button type="primary" @click="cancelAction">取消</el-button>
      <el-button type="primary" @click="sendDataAction">保存</el-button>
    </div>
    <!-- 检索方案弹窗 -->
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" append-to-body>
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
        @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
  </div>
</template>

<script>
import SearchScheme from "../byComponents/SearchScheme.vue"
export default {
  name: 'activityAction',
  props: ['actionData'],
  components: { SearchScheme },
  data() {
    return {
      dataActionBox: {
        showStatus: false,
        boxTitle: '新增',
        actionType: 0, // 0新增，1修改
      },
      // 动态表单字段元数据（由父页面 getJur 的 jurFormVoList 传入，未配置时用本地兜底）
      formConfig: [],
      sendDataInfo: {},
      // 检索方案弹窗
      seWidth: "",
      seTitle: "",
      DialogVisible: false,
      parentSearchData: {},
      seIndex: 0,
      fField: "",
      seType: "",
      seId: "",
      setField: "",
      // 商品明细列表
      detailList: [],
      detailFormConfig: [],
      selectedDetailIndex: -1,
      searchMode: '', // '' 主表单检索，'detail' 明细新增检索
      mxHeight: 300, // 明细表格高度（自适应窗口）
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 父级传入 actionData 后打开（父页面通过 v-if="showStatus" 控制挂载）
    openBox() {
      this.dataActionBox.actionType = this.actionData.cate || 0
      // 表单字段优先取 getJur 返回的 jurFormVoList 第一个表单（jurconfigform），未配置时用本地兜底（字段与 /su/activity/save 对齐）
      var formData = (this.actionData.formData && this.actionData.formData[0])
        ? this.actionData.formData[0].jurconfigform
        : []
      this.formConfig = (formData && formData.length) ? formData : this.getDefaultFormConfig()
      this.initSendData()
      this.initDetailFormConfig()
      // 重置明细列表
      this.detailList = []
      this.selectedDetailIndex = -1
      if (this.dataActionBox.actionType == 0) {
        this.dataActionBox.boxTitle = '新增信息'
      } else {
        this.dataActionBox.boxTitle = '编辑信息'
        var oldData = this.actionData.oldData || {}
        for (const key in this.sendDataInfo) {
          if (oldData[key] !== undefined) {
            this.$set(this.sendDataInfo, key, oldData[key])
          }
        }
        // 编辑时携带主键，供 /su/activity/save 区分新增/修改（主键字段名如不同请替换）
        if (oldData.id !== undefined) {
          this.$set(this.sendDataInfo, 'id', oldData.id)
        }
        // 编辑时加载已有明细
        if (oldData.detailList && Array.isArray(oldData.detailList)) {
          this.detailList = JSON.parse(JSON.stringify(oldData.detailList))
        }
      }
      this.dataActionBox.showStatus = true
      // 抽屉全屏后计算明细表格高度（延迟等抽屉动画完成）
      this.$nextTick(() => {
        this.setMxHeight()
      })
      setTimeout(() => {
        this.setMxHeight()
      }, 300)
    },
    // 明细表格高度自适应（参考 $common.getBtnHeight：总高度 - 表单 - 标题 - 按钮 - 底部栏 - 间距）
    setMxHeight() {
      var drawerBody = document.documentElement.querySelector('.el-drawer__body')
      var totalHeight = drawerBody ? drawerBody.clientHeight : document.documentElement.clientHeight
      // 标题栏高度
      var titleEl = drawerBody ? drawerBody.querySelector('.title_box') : null
      var titleHeight = titleEl ? titleEl.clientHeight : 0
      // 主表单高度
      var formEl = drawerBody ? drawerBody.querySelector('#mainInfo') : null
      var formHeight = formEl ? formEl.clientHeight : 0
      // 明细按钮栏高度
      var btnEl = drawerBody ? drawerBody.querySelector('#operateBtn') : null
      var btnHeight = btnEl ? btnEl.clientHeight : 0
      // 底部操作栏高度
      var footEl = drawerBody ? drawerBody.querySelector('.foot') : null
      var footHeight = footEl ? footEl.clientHeight : 0
      // 计算明细表格可用高度
      var height = totalHeight - titleHeight - formHeight - btnHeight - footHeight - 40
      this.mxHeight = height > 200 ? height : 200
    },
    // 活动表单字段兜底配置（字段与 /su/activity/save 接口对齐；getJur 的 jurFormVoList 就绪后自动走接口下发）
    getDefaultFormConfig() {
      return [
        { entityField: 'activityName', showField: '活动名称', fieldType: 'text', isRequired: 1, isShow: 1, maxlength: 50 },
        {
          entityField: 'status', showField: '状态', fieldType: 'select', isRequired: 0, isShow: 1, defaultValue: 1,
          formatterContent: [
            { key: 1, value: '启用' },
            { key: 0, value: '停用' },
          ],
        },
        { entityField: 'startTime', showField: '活动开始时间', fieldType: 'date', isRequired: 1, isShow: 1 },
        { entityField: 'endTime', showField: '活动结束时间', fieldType: 'date', isRequired: 1, isShow: 1 },
        { entityField: 'pid', showField: '品种(商品ID)', fieldType: 'text', isRequired: 1, isShow: 1 },
        { entityField: 'activityContent', showField: '活动内容', fieldType: 'textarea', isRequired: 0, isShow: 1, maxlength: 200 },
        { entityField: 'remark', showField: '备注', fieldType: 'text', isRequired: 0, isShow: 1, maxlength: 100 },
      ]
    },
    // 根据配置初始化表单数据（含默认值；隐藏字段也初始化，便于检索时作为过滤条件带入，如 stId）
    initSendData() {
      this.sendDataInfo = {}
      this.formConfig.forEach((field) => {
        this.$set(this.sendDataInfo, field.entityField, field.defaultValue !== undefined ? field.defaultValue : '')
      })
    },
    // 初始化明细表单配置（从 getJur 的 jciType==2 获取，未配置时用本地兜底）
    initDetailFormConfig() {
      if (this.actionData.formData && this.actionData.formData.length) {
        var detailForm = this.actionData.formData.find(item => item.jciType == 2)
        if (detailForm && detailForm.jurconfigform && detailForm.jurconfigform.length) {
          this.detailFormConfig = detailForm.jurconfigform
          return
        }
      }
      this.detailFormConfig = this.getDefaultDetailConfig()
    },
    // 明细表单字段兜底配置（商品名称为检索字段，searchId 取主表单 search 字段的配置）
    getDefaultDetailConfig() {
      var mainSearch = this.formConfig.find(f => f.fieldType == 'search') || {}
      return [
        {
          entityField: 'bgmName', showField: '商品名称', isShow: 1, fieldWeight: 200,
          fieldType: 'search', searchId: mainSearch.searchId, setField: mainSearch.setField || 'bgmName,bgmId',
        },
        { entityField: 'bgmId', showField: '商品编号', isShow: 1, fieldWeight: 120 },
        { entityField: 'bgmSpec', showField: '规格', isShow: 1, fieldWeight: 120 },
        { entityField: 'bgmUnit', showField: '单位', isShow: 1, fieldWeight: 80 },
      ]
    },
    // 解析下拉枚举：formatterContent 可能是 JSON 字符串，也可能是数组
    getFormatterOptions(field) {
      if (!field || !field.formatterContent) return []
      if (Array.isArray(field.formatterContent)) return field.formatterContent
      try {
        return JSON.parse(field.formatterContent)
      } catch (e) {
        return []
      }
    },
    // 取消
    cancelAction() {
      this.$emit('drawerCancel', 0)
    },
    // 检索方案：打开检索弹窗
    // 同 openDetailSearch，只带 stId 和当前字段的关键字，避免主表单字段污染检索条件
    openSearch(sId, setField, type, index) {
      this.searchMode = ''
      this.seId = sId
      this.setField = setField
      this.seType = type
      this.seIndex = index
      this.parentSearchData = {
        stId: this.sendDataInfo.stId || '',
      }
      this.parentSearchData[type] = this.sendDataInfo[type] || ''
      this.DialogVisible = true
    },
    // 新增明细：校验主表单 → 检查空白行 → push 空白行 → 聚焦检索字段（参考 salesOrderAction）
    addDetail() {
      this.$refs['sendDataInfo'].validate((valid) => {
        if (!valid) {
          this.$message({ message: '请完善主表单信息', type: 'warning' })
          return
        }
        // 检索字段为空的行视为空白行，不允许重复新增
        var searchField = this.detailFormConfig.find(f => f.fieldType == 'search')
        if (searchField && this.detailList.length > 0) {
          var hasEmpty = this.detailList.some(item =>
            item[searchField.entityField] === '' || item[searchField.entityField] == null)
          if (hasEmpty) {
            this.$message({ message: '请不要重复新增空白行', type: 'warning' })
            return
          }
        }
        // 按明细配置创建空白行
        var newRow = {}
        this.detailFormConfig.forEach(col => {
          if (col.fieldType == 'number') {
            this.$set(newRow, col.entityField, 0)
          } else if (col.fieldType == 'search' && col.setField) {
            // 检索字段的关联字段一并初始化（如 bgmName,bgmId）
            col.setField.split(',').forEach(f => this.$set(newRow, f, ''))
            this.$set(newRow, col.entityField, '')
          } else {
            this.$set(newRow, col.entityField, '')
          }
        })
        this.detailList.push(newRow)
        var newIndex = this.detailList.length - 1
        this.$nextTick(() => {
          this.selectedDetailIndex = newIndex
          // 聚焦新行的检索输入框
          if (searchField) {
            this.tableNextFocus(searchField.entityField, newIndex)
          }
        })
      })
    },
    // 明细行内检索：打开检索弹窗
    // 注意：不能把整个主表单塞进 parentSearchData —— SearchScheme 会把与检索条件同名的字段
    // 当成过滤条件（如 status/startTime/endTime），主表单的值会污染查询导致搜不出数据
    openDetailSearch(sId, index, type, setField) {
      this.searchMode = 'detail'
      this.seId = sId
      this.seIndex = index
      this.seType = type
      this.setField = setField || ''
      // 只带必要的过滤条件：stId + 当前行已输入的检索关键字
      this.parentSearchData = {
        stId: this.sendDataInfo.stId || '',
      }
      this.parentSearchData[type] = this.detailList[index][type] || ''
      this.selectedDetailIndex = index
      this.DialogVisible = true
    },
    // 表格内聚焦指定字段
    tableNextFocus(field, index) {
      this.$nextTick(() => {
        var refs = this.$refs[field]
        if (refs && refs[index]) {
          refs[index].focus()
        }
      })
    },
    // 删除明细
    deleteDetails() {
      if (this.selectedDetailIndex < 0) {
        this.$message({ message: '请先选择要删除的明细', type: 'warning' })
        return
      }
      this.detailList.splice(this.selectedDetailIndex, 1)
      this.$nextTick(() => {
        if (this.detailList.length > 0) {
          this.selectedDetailIndex = this.selectedDetailIndex > 0 ? this.selectedDetailIndex - 1 : 0
        } else {
          this.selectedDetailIndex = -1
        }
      })
    },
    // 明细行点击选中
    clickDetailRow(row) {
      var index = this.detailList.indexOf(row)
      if (index > -1) this.selectedDetailIndex = index
    },
    getSeWidth(e) {
      this.seWidth = e + "%"
    },
    getSearchName(e) {
      this.seTitle = e
    },
    // 检索带回数据（参考 salesOrderAction：$nextTick 中分发，支持多选数组）
    changeInputModel(val) {
      // 原条件 val != "" || val != undefined 恒为 true，改为空值拦截
      if (val == null || val === '') return
      this.DialogVisible = false
      this.$nextTick(() => {
        // 明细行内检索
        if (this.searchMode === 'detail') {
          this.searchMode = ''
          // 多选：逐条校验重复，未重复的才加入
          if (Array.isArray(val)) {
            if (!val.length) return
            val.forEach((item, i) => {
              if (i === 0) {
                // 第一条填当前行（当前行本身就是空行，不需校验）
                this.setDetailRowValue(item)
              } else {
                this.appendDetailRow(item)
              }
            })
            return
          }
          // 单选：校验是否与已有明细重复（排除当前编辑行）
          if (this.isDetailDuplicate(val, this.seIndex)) {
            this.$message({ message: '该商品已在明细列表中，请勿重复添加', type: 'warning' })
            this.tableNextFocus(this.seType, this.seIndex)
            return
          }
          this.setDetailRowValue(val)
          return
        }
        this.paramValue(val)
      })
    },
    // 校验检索带回的商品是否与明细列表重复（excludeIndex 排除当前编辑行）
    isDetailDuplicate(val, excludeIndex) {
      var bgmId = this.getValIgnoreCase(val, 'bgmId')
      if (!bgmId) return false
      return this.detailList.some((item, index) =>
        index !== excludeIndex && item.bgmId === bgmId)
    },
    // 大小写不敏感取值
    getValIgnoreCase(obj, field) {
      if (obj[field] != null) return obj[field]
      var lower = field.toLowerCase()
      for (var key in obj) {
        if (key.toLowerCase() === lower) return obj[key]
      }
      return null
    },
    // 检索带回数据 -> 整行合并到当前明细行（参考 applyBgmDetail：Object.assign 带回全部字段）
    setDetailRowValue(val) {
      var row = this.detailList[this.seIndex]
      if (!row) return
      // 先整行合并，让明细配置里的所有列（规格/单位/厂家等）都能回显
      Object.assign(row, val)
      // 再按 setField 补充（兼容 setField 与检索返回字段大小写不一致的情况）
      this.applySetField(row, val)
      // 强制刷新该行引用，确保表格重新渲染
      this.detailList.splice(this.seIndex, 1, Object.assign({}, row))
      this.$nextTick(() => {
        this.selectedDetailIndex = this.seIndex
        this.tableNextFocus(this.seType, this.seIndex)
      })
    },
    // 追加一行明细（多选场景：校验重复后按明细配置提取字段）
    appendDetailRow(val) {
      if (this.isDetailDuplicate(val, -1)) {
        this.$message({ message: '商品[' + (this.getValIgnoreCase(val, 'bgmName') || '') + ']已在明细列表中，已跳过', type: 'warning' })
        return
      }
      var row = {}
      this.detailFormConfig.forEach(col => {
        this.$set(row, col.entityField, col.fieldType == 'number' ? 0 : '')
      })
      Object.assign(row, val)
      this.applySetField(row, val)
      this.detailList.push(row)
      this.selectedDetailIndex = this.detailList.length - 1
    },
    // 按 setField 配置赋值（大小写不敏感匹配，兼容后端配置 bgmid / 返回 bgmId 的情况）
    applySetField(target, source) {
      if (!this.setField) return
      this.setField.split(',').forEach(item => {
        if (!item) return
        var value = source[item]
        if (value === undefined) {
          var lowerItem = item.toLowerCase()
          for (var key in source) {
            if (key.toLowerCase() === lowerItem) {
              value = source[key]
              break
            }
          }
        }
        if (value != null && value !== '') {
          this.$set(target, item, value)
        }
      })
    },
    // 赋值字段（用 $set 确保响应式更新）
    paramValue(val) {
      console.log('paramValue setField:', this.setField, 'val:', val)
      if (this.setField != null && this.setField != '' && this.setField != undefined) {
        let arr = this.setField.split(',')
        arr.forEach(item => {
          console.log('赋值:', item, '=', val[item])
          this.$set(this.sendDataInfo, item, val[item])
        })
      } else {
        console.log('走else seType:', this.seType, '=', val[this.seType])
        this.$set(this.sendDataInfo, this.seType, val[this.seType])
      }
    },
    // 保存/修改（统一走 /su/activity/save）
    async sendDataAction() {
      // 按配置校验必填项
      for (let i = 0; i < this.formConfig.length; i++) {
        var field = this.formConfig[i]
        if (field.isShow == 1 && field.isRequired == 1 &&
          (this.sendDataInfo[field.entityField] === '' || this.sendDataInfo[field.entityField] === undefined || this.sendDataInfo[field.entityField] === null)) {
          this.$message({ message: '请填写' + field.showField, type: 'error' })
          return false
        }
      }
      try {
        // 保存时带上明细列表
        this.$set(this.sendDataInfo, 'detailList', this.detailList)
        var responseData = await this.$http.saveActivity(this.sendDataInfo)
        if (responseData && responseData.status == 200) {
          this.$message({ message: '操作成功', type: 'success' })
          this.$emit('drawerCancel', 1)
        } else {
          this.$message({ message: (responseData && responseData.message) || '操作失败', type: 'error' })
        }
      } catch (e) {
        this.$message({ message: '操作失败', type: 'error' })
      }
    },
  },
  created() {
    this.$nextTick(() => {
      this.openBox()
    })
  },
  mounted() { },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
}
</script>
<style scoped>
.table_content_box {
  overflow-y: auto;
}

.title_box {
  padding: 12px 16px;
  font-weight: bold;
  border-bottom: 1px solid #E4E7ED;
}

/* 主表单区 + 明细区统一 padding */
.table_content_box > .baseForm,
#operateBtn {
  padding: 16px;
}

#operateBtn {
  padding-bottom: 0;
}

/* 全屏抽屉下表单字段横向排布 */
.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.baseForm .el-textarea,
.baseForm .el-select,
.baseForm .el-date-editor.el-input,
.baseForm .el-input {
  width: 200px;
}
</style>
